<template>
  <article class="container col-md-6" v-if="application.title">
    <h1>Your Application for <span class="job-title">{{application.title}}</span></h1>
    <hr/>
    <ul class="list-group changes-list">
      <li data-toggle="{{ index == 0 ? 'tooltip' : '' }}" data-placement="top"
          title="{{messages[change.status].message}}" v-for="(index, change) in application.changes"
          class="list-group-item status-{{ change.status }}">
        <h4 class="list-group-item-heading" style="width: 100%;">
          <span class="">{{ messages[change.status].title }}</span>
          <small class="text-muted pull-md-right">{{ change.created | date '%a %d.%m %R' }}</small>
        </h4>
        <div id="interview" class="interview-selecting list-group-item-text"
             v-if="application.changes[0].status == 3 && change.status == 3 && index == 0">
          <p>{{ change.description }}</p>
          <div class="interview-date">
            <div class="assigned-date">
              <p>Interview Date: {{ application.interview.date }}</p>
              <button v-on:click="confirmInterview" class="btn btn-507 center-block">Confirm Visit</button>
            </div>
            <i>In case you are not available on our propose date, please suggest your first available termin.</i>
            <div class="suggest-date">
              <p>Suggest your Date</p>
              <div id="interviewDate"></div>
              <p>Note <input v-model="newDate.note" type="text"/></p>
              <div class="button-wrap">
                <button v-on:click="confirmNewDate" class="btn btn-507 center-block">suggest New Date</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="application.changes[0].status == 4 && change == application.changes[0]"
               class="list-group-item-text">
            <p>
              You have interview <strong>{{ application.interview.date }}</strong>,
              <a href="https://goo.gl/maps/amL8CXuznB52" class="map-link" target="_blank">Vilharjeva cesta 3, 1000
                Ljubljana</a>
            </p>
            <map
              :center="mapLocation.center"
              :zoom="15"
              :options="mapOptions"
            >
              <marker
                :position.sync="mapLocation.pos"
                :clickable="true"
                @g-click="mapMarker"
              ></marker>
            </map>
          </div>
          <div v-else v-if="index == 0">
            <div v-if="application.changes[0].status == 8">
              <button v-on:click="storedYes" class="btn btn-507 center-block" :class="{ 'light': stored == 2 }">
                Yes, I agree, keep my application for the future
              </button>
              <button v-on:click="storedNo" class="btn btn-507 center-block" :class="{ 'light': stored == 1 }">
                My application will expire soon, do not keep it
              </button>
            </div>
            <p>{{ change.description }}</p>
          </div>
        </div>
      </li>
    </ul>
  </article>
  <article class="container col-md-6" v-else>
    <h1>No application found with that UUID</h1>
    <div class="middle-button">
      <a v-link="'/'" class="btn btn-primary">Go Home</a>
    </div>
  </article>
</template>

<style lang="sass">
  @import '../assets/scss/colors'
  @import '../assets/scss/bootstrap'

  map
    height: 20rem
    display: block
    margin-left: -1.25rem
    // Fix for padding
    margin-right: -1.25rem
    // Fix for padding
    margin-bottom: -2.5rem
  // Fix for padding && hide google text

  .map-link
    text-decoration: none
    color: $text-light-secondary
    font-weight: bold

    &:hover,
    &:active,
    &:focus
      text-decoration: none
      color: $text-light-primary

  .job-title
    color: $black-507

  .changes-list
    .list-group-item
      &:first-child
        background: $black-507
        color: $text-light-secondary

  .middle-button
    display: flex
    justify-content: center

  .interview-selecting
    display: flex
    flex-direction: column

    p
      margin: 0

    .interview-date
      width: 100%
      display: flex
      flex-direction: column
      text-transform: uppercase
      font-weight: bold
      margin-bottom: 0.5em
      margin-top: 0.5em

      > div:not(.suggest-date)
        display: flex
        flex-direction: row
        justify-content: space-between

      i
        font-weight: 300
        text-transform: none
        margin-bottom: 0.5em
        font-size: 0.85em

      .assigned-date
        margin: 3em 0
        p
          align-self: center
          margin: 0
          font-size: 1.1em
    .btn-507
      margin-bottom: 0.5em
      color: $text-light-primary
      &:hover
        color: $black
        cursor: pointer

  .suggest-date
    p
      margin: 0 0 20px 0
    #interviewDate
      width: 250px

    .button-wrap
      .btn-507
        font-size: 1.1em
        &:hover
          color: $black
          cursor: pointer

      input
        color: $text-light-primary

  @media screen and (max-width: map_get($grid-breakpoints, "sm"))
    .list-group-item-heading
      span
        width: 100%
        display: block
      small
        display: block
        width: 100%

</style>

<script>
    import { showAlert } from '../vuex/actions'
    import moment from 'moment'

    import {load, Map, Marker, loaded} from 'vue-google-maps'
    load('AIzaSyBzlLYISGjL_ovJwAehh6ydhB56fCCpPQw');

    export default{
      components: {
        map: Map,
        marker: Marker
      },
      data() {
        return {
          stored: false,
          mapLocation: {
            center: {
              lat: 46.059937,
              lng: 14.507978
            },
            pos: {
              lat: 46.059937,
              lng: 14.507978
            }
          },
          mapOptions: {
            styles: [
              {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                  {
                    "color": "#444444"
                  }
                ]
              },
              {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                  {
                    "color": "#f2f2f2"
                  }
                ]
              },
              {
                "featureType": "landscape.man_made",
                "elementType": "geometry",
                "stylers": [
                  {
                    "visibility": "on"
                  }
                ]
              },
              {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                  {
                    "saturation": -100
                  },
                  {
                    "lightness": 45
                  }
                ]
              },
              {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "simplified"
                  }
                ]
              },
              {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                  {
                    "visibility": "off"
                  }
                ]
              },
              {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                  {
                    "color": "#4f595d"
                  },
                  {
                    "visibility": "on"
                  }
                ]
              }
            ],
            streetViewControl: false,
            zoomControl: false,
            rotateControl: false,
            panControl: false,
            mapTypeControl: false
          },
          newDate: {
            date: null,
            note: null
          },
          application: {},
          messages: {
            0:{
              title: 'Your application was send',
              message: 'We haven\'t yet reviewed your Application.'
            },
            1:{
              title: 'Thank you for your interest',
              message: 'You can still follow our new vacancies.'
            },
            2:{
              title: 'Consideration',
              message: 'Your application is being Reviewed.'
            },
            3:{
              title: 'Invited to the Interview',
              message: 'You have been assigned an interview date. If it doesn\'t suits you, you can propose a new one here.'
            },
            4:{
              title: 'Interview Confirmed',
              message: 'We hope to see you at the interview in our studio. Click on red bubble for Google Maps'
            },
            5:{
              title: 'Welcome to our Team',
              message: 'Congratulations! Your Application has been Approved. We hope to see you soon.'
            },
            // This are 6/7 that reflect interview changes later after it's been in production.
            //  That's why it's weird order.
            6:{
              title: 'Interview Date waiting for Approval',
              message: 'Your selected date is waiting for approval. We will notify you when approved.'
            },
            7:{
              title: 'Not Accepted after Interview',
              message: ''
            },
            8:{
              title: 'We would like to store your contact',
              message: ''
            }
          }
        }
      },
      ready() {
        this.loadData();
        // refresh every 5 minutes
        setInterval(this.loadData, 1000*60*5);
      },
      vuex: {
        actions: {
          alert: showAlert
        }
      },
      methods: {
        mapMarker () {
          // Open google maps with location of Studio
          window.open('https://goo.gl/maps/amL8CXuznB52' ,'_blank')
        },
        confirmInterview () {
          var data = new FormData();

          data.append('uuid', this.$route.params.uuid);
          data.append('interview', this.application.interview.id);

          this.$http.post('applications/interview', data).then((response) => {
            this.loadData();
            this.alert("Success", "Interview was confirmed.", "success")
          }, (response) => {
            this.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
          });
        },
        confirmNewDate () {

          if (!this.newDate) {
            this.alert("Whops!", "You have to select date first.", "danger")
          } else {
            var data = new FormData();

            data.append('uuid', this.$route.params.uuid);
            data.append('interview', moment($('#interviewDate').data("DateTimePicker").date()).format())
            data.append('note', this.newDate.note);

            this.$http.post('applications/interview', data).then((response) => {
              this.loadData();
              this.alert("Success", "Interview date was saved.", "success")
            }, (response) => {
              this.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
            });
          }
        },
        loadData () {
          if(this.$route.params.uuid)
          {
            this.$http.get('applications/'+ this.$route.params.uuid).then((response) => {
              var data = response.data.data;

              if(data.interview) {
                var date = moment(data.interview.date, "YYYY-MM-DD HH:mm:ss");
                data.interview.date = date.isValid() ? date.format("DD-MM-YYYY") + " at " + date.format("HH:mm") : "Not set yet";
              }

              this.$set('application', data);
              this.stored = response.data.data.stored;
              $(function () {
                $('[data-toggle="tooltip"]').tooltip();
                $('#interviewDate').datetimepicker({
                  daysOfWeekDisabled: [0, 6],
                  icons: {
                    time: 'fa fa-clock-o',
                    date: 'fa fa-calendar',
                    up: 'fa fa-chevron-up',
                    down: 'fa fa-chevron-down',
                    previous: 'fa fa-chevron-left',
                    next: 'fa fa-chevron-right',
                    today: 'fa fa-desktop',
                    clear: 'fa fa-trash',
                    close: 'fa fa-times'
                  },
                  minDate: moment().add(1, 'd'),
                  maxDate: moment().add(3, 'w'),
                  stepping: 15,
                  inline: true,
                  sideBySide: true,
                  locale: 'sl'
                })
              })
            }, (response) => {
              console.log("API ERROR", response);
            });
          }
        },
        storedYes () {
          var data = new FormData();

          data.append('uuid', this.$route.params.uuid);
          data.append('aoutcome', 1);

          this.$http.post('applications/store', data).then((response) => {
            this.loadData();
            this.alert("Success", "Saved.", "success")
          }, (response) => {
            this.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
          });
        },
        storedNo () {
          var data = new FormData();

          data.append('uuid', this.$route.params.uuid);
          data.append('aoutcome', 0);

          this.$http.post('applications/store', data).then((response) => {
            this.loadData();
            this.alert("Success", "Saved.", "success")
          }, (response) => {
            this.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
          });
        }
      }
    }










</script>



// WEBPACK FOOTER //
// viewApplication.vue?24249a02